import { BillingType } from "@enums/billing-type.enum";

export class BillingFreeItem {
    public name: string;
    public value: number;
    public tva: number;
    public priceHtva: number;
    public priceTva: number;

    public totalHtva: number;
    public totalTva: number;

    public id: number;
    billingType?: BillingType;
}
